import { Box } from "@mui/material";
import Typography from "../typography/typography";
import "./value-field.scss";

interface ValueFieldProps {
  label: string;
  children: React.ReactNode;
  childrenTypoProps?:any
}

const ValueField = (props: ValueFieldProps) => {
  const { label, children, childrenTypoProps } = props;

  return (
    <Box  className="valueField--Container" >
      <Typography weight={"medium"} type="s3"  color={"theme.secondary.1000"}>
        {label}
      </Typography>
      <Typography weight={"medium"} type="s5" color={"theme.secondary.700"} sx={{ wordBreak:'break-all', pr: 1 }} {...childrenTypoProps}>
        {children}
      </Typography>
    </Box>
  );
};

export { ValueField };
export default ValueField;
